import getConfig from 'next/config'
import * as Sentry from '@sentry/browser'

interface Data {
  seri_number: string
  human_key: string
}

export const searchCD = async (params: Data): Promise<CDResult | undefined> => {
  const { publicRuntimeConfig } = getConfig()
  const { LAMDA_VERIFY_CD } = publicRuntimeConfig
  try {

    const data: CDResult = await fetch(LAMDA_VERIFY_CD, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(params)
    }).then(res => res.json())

    if (data?._id) {
      return data
    }

  } catch (ex) {
    Sentry.captureException(ex)
  }
}